module.exports = __webpack_public_path__ + "static/media/hyundai-icon-noneOption.1583b8fb.svg";